export enum EnumComandas {
    INVALIDO = 0,
    ATIVO = 1,
    INATIVO = 2,
}